// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__-af0Z","logo":"Logo_logo__YYM7w"};